import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

export interface SubpageSidebarMenuCategory {
    label?: string;
    children?: SubpageSidebarMenuEntry[];
    hidden?: boolean;
}

export interface SubpageSidebarMenuEntry {
    label?: string;
    heroicon?: string;
    flaticon?: string;
    route?: string;
    customMethod?: () => void;
    hidden?: boolean;
}

@Component({
    standalone: false,
    selector: 'app-subpage-sidebar',
    templateUrl: './subpage-sidebar.component.html',
    styleUrls: ['./subpage-sidebar.component.scss']
})
export class SubpageSidebarComponent {
    expanded = true;

    @ContentChild('upperContentTemplate') upperContentTemplate: TemplateRef<any>;
    @ContentChild('lowerContentTemplate') lowerContentTemplate: TemplateRef<any>;

    @Input() menuEntries: SubpageSidebarMenuCategory[] = [];
    @Input() bottomMenuEntries: SubpageSidebarMenuCategory[] = [];

    handleClick(event: MouseEvent, item: SubpageSidebarMenuEntry): void {
        if (item?.customMethod && !event.metaKey && !event.ctrlKey) {
            event.preventDefault();
            item.customMethod();
        }
    }
}
